(function () {
  var STORAGE_KEY = 'pkWishlistItemsV1';
  var WEBHOOK = 'https://hooks.zapier.com/hooks/catch/6329132/u6we866/';
  var pulseTimer = null;
  var HEART_ICON = 'heart';
  var HEART_ACTIVE_COLOR = '#cba8f9';
  var HEART_INACTIVE_COLOR = '#cba8f9';
  var FONT_AWESOME_HREF = 'https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css';
  var SHOP_DOMAIN_PATTERN = /^(https?:)?\/\/(www\.)?purebredkitties\.com(?=\/|$)/i;
  var DETAILS_VIEW_SUFFIX = 'recomended_view';
  var wishlistDetailsCache = {};
  var REMOVE_BUTTON_ICON = '';
  var lastRemoveActivationAt = 0;

  function safeParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getItems() {
    var parsed = safeParse(localStorage.getItem(STORAGE_KEY));
    return Array.isArray(parsed) ? parsed : [];
  }

  function setItems(items, previousCount) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    renderLegacyHearts();
    syncButtons();
    renderWishlistPage();
    updateCounters(typeof previousCount === 'number' ? previousCount : items.length);
  }

  function getPreviewThemeId() {
    try {
      var fromUrl = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (fromUrl) {
        return fromUrl;
      }
    } catch (error) {
    }

    var previewFrame = document.querySelector('iframe[src*="preview_theme_id="]');
    if (previewFrame) {
      try {
        return new URL(previewFrame.getAttribute('src'), window.location.origin).searchParams.get('preview_theme_id') || '';
      } catch (error) {
      }
    }

    var previewLink = document.querySelector('a[href*="preview_theme_id="]');
    if (previewLink) {
      try {
        return new URL(previewLink.getAttribute('href'), window.location.origin).searchParams.get('preview_theme_id') || '';
      } catch (error) {
      }
    }

    return '';
  }

  function isPreviewSession() {
    return !!getPreviewThemeId();
  }

  function rewritePreviewHref(url) {
    if (!url || !isPreviewSession()) {
      return url;
    }

    try {
      var isAbsoluteShopUrl = SHOP_DOMAIN_PATTERN.test(url);
      var isRelativeShopUrl = url.charAt(0) === '/';

      if (!isAbsoluteShopUrl && !isRelativeShopUrl) {
        return url;
      }

      var targetUrl = new URL(url, window.location.origin);
      var previewUrl = new URL(targetUrl.pathname + targetUrl.search + targetUrl.hash, window.location.origin);
      previewUrl.searchParams.set('preview_theme_id', getPreviewThemeId());
      return isRelativeShopUrl
        ? previewUrl.pathname + previewUrl.search + previewUrl.hash
        : previewUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function syncPreviewOriginLinks(root) {
    if (!isPreviewSession()) return;

    (root || document).querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.indexOf('javascript:') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      if (!SHOP_DOMAIN_PATTERN.test(href)) return;

      var rewrittenHref = rewritePreviewHref(href);
      if (rewrittenHref && rewrittenHref !== href) {
        link.setAttribute('href', rewrittenHref);
      }
    });
  }

  function normalizeItem(raw) {
    if (!raw) return null;

    var productId = String(raw.productId || raw.id || '').trim();
    var handle = String(raw.handle || '').trim();
    var url = String(raw.url || '').trim();

    if (!productId || !handle || !url) {
      return null;
    }

    return {
      productId: productId,
      handle: handle,
      url: rewritePreviewHref(url),
      title: String(raw.title || '').trim(),
      breed: String(raw.breed || '').trim(),
      image: String(raw.image || '').trim(),
      variantId: String(raw.variantId || '').trim(),
      variantName: String(raw.variantName || '').trim(),
      price: String(raw.price || '').trim(),
      priceFormatted: String(raw.priceFormatted || '').trim(),
      cardHtml: ''
    };
  }

  function findIndex(productId) {
    var items = getItems();
    for (var i = 0; i < items.length; i += 1) {
      if (String(items[i].productId) === String(productId)) {
        return i;
      }
    }
    return -1;
  }

  function hasItem(productId) {
    return findIndex(productId) !== -1;
  }

  function getItemById(productId) {
    var items = getItems();
    for (var i = 0; i < items.length; i += 1) {
      if (String(items[i].productId) === String(productId)) {
        return items[i];
      }
    }
    return null;
  }

  function addItem(item) {
    var normalized = normalizeItem(item);
    if (!normalized) return null;

    var items = getItems();
    var previousCount = items.length;
    var existingIndex = findIndex(normalized.productId);

    if (existingIndex !== -1) {
      items[existingIndex] = normalized;
    } else {
      items.unshift(normalized);
      sendWishlistWebhook(normalized);
    }

    setItems(items, previousCount);
    return normalized;
  }

  function removeItem(productId) {
    var items = getItems();
    var previousCount = items.length;
    var nextItems = items.filter(function (item) {
      return String(item.productId) !== String(productId);
    });

    setItems(nextItems, previousCount);
  }

  function toggleItem(item) {
    if (!item || !item.productId) return false;

    if (hasItem(item.productId)) {
      removeItem(item.productId);
      return false;
    }

    addItem(item);
    return true;
  }

  function getProductData(source) {
    if (!source) return null;

    var dataset = source.dataset || {};
    var marker = source.closest('.zoomywishid, .wishlist-section, .wishlist_w, .thub_box, .product_outer, .product-grid-item, .product-item, article, li, div');
    var meta = marker && marker.classList.contains('zoomywishid') ? marker : marker ? marker.querySelector('.zoomywishid') : null;
    var metaDataset = meta ? meta.dataset : {};

    return normalizeItem({
      productId: dataset.productId || metaDataset.productId,
      handle: dataset.handle || metaDataset.handle,
      url: dataset.url || metaDataset.url,
      title: dataset.title || metaDataset.title,
      breed: dataset.breed || metaDataset.breed,
      image: dataset.image || metaDataset.image,
      variantId: dataset.variantId || metaDataset.variant,
      variantName: dataset.variantName || metaDataset.variantname,
      price: dataset.price || metaDataset.price,
      priceFormatted: dataset.priceFormatted || metaDataset.priceFormatted
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function injectRemoveButton(cardHtml, productId) {
    if (!cardHtml) return '';

    var removeButton = "<button class='wishlist-card-remove' aria-label='Remove from wishlist' value='" + productId + "' data-pk-wishlist-remove='" + productId + "'>" + REMOVE_BUTTON_ICON + "</button>";
    return cardHtml.replace(
      '<div class=\"product-grid-item__image\" data-product-media-container>',
      '<div class=\"product-grid-item__image\" data-product-media-container>' + removeButton
    );
  }

  function getDetailsUrl(item) {
    if (!item || !item.handle) return '';
    var baseUrl = rewritePreviewHref('/products/' + item.handle);
    return baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'view=' + DETAILS_VIEW_SUFFIX;
  }

  function fetchWishlistDetails(item) {
    if (!item || !item.handle) {
      return Promise.resolve(null);
    }

    if (wishlistDetailsCache[item.handle]) {
      return Promise.resolve(wishlistDetailsCache[item.handle]);
    }

    return fetch(getDetailsUrl(item), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Wishlist card details request failed');
        }
        return response.text();
      })
      .then(function (html) {
        if (!html || html.indexOf('product-grid-item') === -1) {
          throw new Error('Wishlist card details payload is invalid');
        }

        var details = {
          title: item.title,
          card_html: injectRemoveButton(html.replace(/Meet Me/g, 'Reserve Me'), item.productId)
        };

        wishlistDetailsCache[item.handle] = details;
        return details;
      });
  }

  function ensureFontAwesome() {
    if (document.querySelector('link[data-pk-wishlist-font-awesome]')) return;

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONT_AWESOME_HREF;
    link.setAttribute('data-pk-wishlist-font-awesome', 'true');
    document.head.appendChild(link);
  }

  function ensureLegacyClasses() {
    document.documentElement.classList.add('swym-ready');
    if (document.body) {
      document.body.classList.add('swym-ready');
      if (document.getElementById('ZoomyWishlistPage')) {
        document.body.classList.add('body-wishlist');
      }
    }
  }

  function buildLegacyHeart(productId, active) {
    var heartClass = active ? 'fa-' + HEART_ICON : 'fa-' + HEART_ICON + '-o';
    var stateClass = active ? 'zadbg' : 'zrmvbg';
    var checked = active ? " checked='true'" : '';
    var color = active ? HEART_ACTIVE_COLOR : HEART_INACTIVE_COLOR;

    return "<div class='zoomywishidheart' style='position:relative;'><input type='checkbox' data-id='" + productId + "' class='zoomycheck checkbox-" + productId + "' id='checkbox-" + productId + "'" + checked + "/><label for='checkbox-" + productId + "'><p class='zooomywishmsg " + stateClass + " zooomywishmsg-" + productId + "' style='cursor:pointer;'><i class='fa " + heartClass + "' style='color: " + color + ";' aria-hidden='true'></i></p></label></div>";
  }

  function renderLegacyHearts(root) {
    var scope = root || document;
    scope.querySelectorAll('.zoomywishid').forEach(function (node) {
      var productId = node.dataset.productId;
      if (!productId) return;
      if (node.closest('.wishlist_w')) return;
      node.innerHTML = buildLegacyHeart(productId, hasItem(productId));
    });
  }

  function syncButton(button) {
    if (!button) return;

    var productId = button.dataset.productId;
    var active = productId ? hasItem(productId) : false;

    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    button.classList.toggle('is-active', active);
    button.dataset.inWishlist = active ? 'true' : 'false';
  }

  function syncButtons(root) {
    (root || document).querySelectorAll('[data-pk-wishlist-button]').forEach(syncButton);
  }

  function updateCounters(previousCount) {
    var count = getItems().length;

    document.querySelectorAll('#wishCount, #wishlist-counter, [data-wishlist-count], #zooomy-wishlist-counter').forEach(function (node) {
      node.textContent = count;
      node.innerHTML = '<span>' + count + '</span>';
    });

    if (count !== previousCount) {
      pulseFloatingHeart();
    }

    window.dispatchEvent(new CustomEvent('pk:wishlist:updated', {
      detail: {
        count: count,
        previousCount: previousCount
      }
    }));
  }

  function pulseFloatingHeart() {
    var heart = document.querySelector('.scroll-up-button.heart-scroll svg');
    if (!heart) return;

    if (pulseTimer) {
      clearTimeout(pulseTimer);
    }

    heart.classList.add('wishlist-pulse');
    pulseTimer = setTimeout(function () {
      heart.classList.remove('wishlist-pulse');
      pulseTimer = null;
    }, 5000);
  }

  function buildWishlistPage(items) {
    return items.map(function (item) {
      var details = item && item.details ? item.details : null;
      var cardHtml = details.card_html;
      var productId = escapeHtml(item.productId);

      return cardHtml.replace(
        "class='product-grid-item",
        "id='ZoomyWishlistPageGrid-" + productId + "' class='product-grid-item"
      );
    }).join('');
  }

  function renderWishlistPage() {
    var container = document.getElementById('ZoomyWishlistPage') || document.querySelector('[data-pk-wishlist-page]');
    if (!container) return;

    var items = getItems();

    if (!items.length) {
      container.innerHTML = "<div class='zwishemptymsg'><p class='zmsg'>Your wishlist is empty</p></div>";
      return;
    }

    container.innerHTML = "<div class='zwishemptymsg'><p class='zmsg'>Loading wishlist...</p></div>";

    Promise.all(items.map(function (item) {
      return fetchWishlistDetails(item).then(function (details) {
        return Object.assign({}, item, { details: details });
      });
    }))
      .then(function (itemsWithDetails) {
        container.innerHTML = "<div class='grid'>" + buildWishlistPage(itemsWithDetails) + "</div>";
      })
      .catch(function (error) {
        console.error(error);
        container.innerHTML = "<div class='zwishemptymsg'><p class='zmsg'>Wishlist failed to load</p></div>";
      });
  }

  function getCustomerData() {
    if (window.Customer && window.Customer.email) {
      return {
        name: [window.Customer.first_name, window.Customer.last_name].filter(Boolean).join(' ') || 'Unknown',
        email: window.Customer.email
      };
    }

    var cached = safeParse(localStorage.getItem('customer_data'));
    if (cached) {
      return {
        name: cached.name || 'Unknown',
        email: cached.email || 'Unknown'
      };
    }

    return {
      name: 'Unknown',
      email: 'Unknown'
    };
  }

  function sendWishlistWebhook(item) {
    var payload = {
      event: 'product_added_to_wishlist',
      timestamp: new Date().toISOString(),
      customer: getCustomerData(),
      product: {
        id: item.productId,
        name: item.title || 'Unknown',
        category: item.breed || 'Unknown',
        breed: item.breed || 'Unknown',
        key: item.productId + '-' + (item.title || 'Unknown')
      }
    };

    fetch(WEBHOOK, {
      method: 'POST',
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  function handleLegacyHeartToggle(event) {
    var checkbox = event.target.closest('.zoomycheck');
    if (!checkbox) return false;

    var source = checkbox.closest('.zoomywishid');
    var item = getProductData(source);
    if (!item) return true;

    toggleItem(item);
    return true;
  }

  function handleWishlistRemoveActivation(event) {
    var removeButton = event.target.closest('[data-pk-wishlist-remove]');
    if (!removeButton) return false;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }

    var now = Date.now();
    if (event.type === 'click' && now - lastRemoveActivationAt < 700) {
      return true;
    }

    lastRemoveActivationAt = now;
    removeItem(removeButton.dataset.pkWishlistRemove || removeButton.value);
    return true;
  }

  function handleDocumentClick(event) {
    if (handleWishlistRemoveActivation(event)) {
      return;
    }

    var openButton = event.target.closest('[data-pk-wishlist-open]');
    if (openButton) {
      event.preventDefault();
      window.location.href = rewritePreviewHref(openButton.dataset.pkWishlistOpen);
      return;
    }

    var button = event.target.closest('[data-pk-wishlist-button]');
    if (button) {
      event.preventDefault();
      var item = getProductData(button);
      if (!item) return;
      toggleItem(item);
      return;
    }

    var continueButton = event.target.closest('[data-pk-wishlist-continue]');
    if (continueButton) {
      event.preventDefault();
      window.location.href = rewritePreviewHref('https://purebredkitties.com/collections/kittens-for-sale');
    }
  }

  function observeNewNodes() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          syncPreviewOriginLinks(node);
          renderLegacyHearts(node);
          syncButtons(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    ensureFontAwesome();
    ensureLegacyClasses();
    syncPreviewOriginLinks();
    renderLegacyHearts();
    syncButtons();
    renderWishlistPage();
    updateCounters(getItems().length);
    if (window.PointerEvent) {
      document.addEventListener('pointerup', handleWishlistRemoveActivation, true);
    } else {
      document.addEventListener('touchend', handleWishlistRemoveActivation, true);
    }
    document.addEventListener('click', handleDocumentClick, true);
    document.addEventListener('change', handleLegacyHeartToggle);
    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) {
        renderLegacyHearts();
        syncButtons();
        renderWishlistPage();
        updateCounters(getItems().length);
      }
    });
    observeNewNodes();
  }

  window.pkWishlist = {
    getItems: getItems,
    hasItem: hasItem,
    getItemById: getItemById,
    addItem: addItem,
    removeItem: removeItem,
    toggleItem: toggleItem,
    syncButtons: syncButtons,
    renderWishlistPage: renderWishlistPage,
    updateCounters: updateCounters,
    renderLegacyHearts: renderLegacyHearts
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
